import { render, staticRenderFns } from "./InkindMatchCreate.vue?vue&type=template&id=28bff3f4&"
import script from "./InkindMatchCreate.vue?vue&type=script&lang=js&"
export * from "./InkindMatchCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports